import React from 'react'
import BlogPost from './BlogPost'

export default function DataIsTheOxygenOfAi() {
  return (
    <BlogPost
      translationKey="dataIsTheOxygenOfAi"
      seoTitle="Data is the Oxygen of AI | Hyunjin Jae"
      seoDescription="Why high-quality data fuels AI systems, covering data collection, labeling, and governance for effective models."
      seoKeywords="AI, data quality, data governance, machine learning, labeling, MLOps"
      seoTags={['AI', 'data', 'machine learning', 'MLOps', 'data governance']}
    />
  )
} 